import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CodeInputComponent } from '@rogers/cdk/form';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { LiveChatService } from 'src/app/livechat/livechat.service';
import { CounterDirective } from 'src/app/shared/counter.directive';
import { ConfigurationService } from 'src/app/shared/configuration.service';
import { CookieService } from 'ngx-cookie-service';


@Component({
    selector: 'app-recovery-number-otp-confirmation',
    templateUrl: './recovery-number-otp-confirmation.component.html',
    styleUrls: ['./recovery-number-otp-confirmation.component.scss'],
    standalone: false
})
export class RecoveryNumberOtpConfirmationComponent implements OnInit, AfterViewInit,OnDestroy  {

  otpLength = 6;
  optTargetDescription = '';
  otp = '';
  formSubmitted = false;
  resendCodeClick = false;
  resendDisabled = true;
  verifyUserForm: UntypedFormGroup;
  verifyType = 'verifySms';
  selectedTargetType: com.ts.mobile.sdk.OtpTarget;
  private readonly windowObj: Window;
  @ViewChild('codeInputRef') codeInputRef: CodeInputComponent;
  otpFormError = false;
  @ViewChild('continueBtn', { read: ElementRef, static: true })
  continueBtn: ElementRef;
  @ViewChildren(CounterDirective) CounterDirective;
  targets: Array<com.ts.mobile.sdk.AuthenticatorTarget>;

  loginStart = false;
  loginInProgress = false;
  counter: number;
  counterInitialValue: number;
  altType: string;

  maxOtpAttemptsTried = false;
  incorrectCode = false;
  expiredCode = false;
  targetsCount = 0;
  otherError = false;

  email: string;
  mobile: string;

  showHelp = true;
  brand = '';
  // liveChatURL = '';

  track = {
    changeMobileOtpPageview: {
      pageView: true,
      isModalPopup: false,
      mappingKey: 'change-mobile-otp',
    },
    changeMobileOtpErrors: {
      pageView: false,
      isModalPopup: false,
      mappingKey: 'change-mobile-otp',
      category: 'self serve',
      type: '',
      code: '',
      API: this.configurationService.config.analyticsAPIUrl,
      field: ''
    },
    changeMobileOtpFormError: {
      pageView: false,
      isModalPopup: false,
      mappingKey: 'change-mobile-otp',
      category: 'self serve',
      type: 'form',
      code: '',
      API: '',
      field: 'sms verification code'
    },
    changeMobileOtpResendCode: {
      pageView: false,
      isModalPopup: false,
      mappingKey: 'change-mobile-otp-resend-code'
    }
  };

  public onSubmitCode: (code: string) => void;
  public onResend: () => void;
  public onChangeRecoveryNumber: () => void;

  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly translate: TranslateService,
    private readonly titleService: Title,
    private readonly liveChatService: LiveChatService,
    private readonly cookieService: CookieService
  ) {
    this.windowObj = !!window.frameElement
      ? (window.parent as any)
      : (window as any);
  }

  public setWaitingInfo = (length: number, targetDescription: string) => {
    this.otpLength = length;

    if (this.mobile !== '' && this.mobile !== undefined && this.mobile !== null){
      this.optTargetDescription  = this.mobile;
    }
    else{
      this.optTargetDescription = targetDescription;
    }
  }

  ngOnInit() {
    this.cookieService.set('profilePage', 'recoveryNumber',undefined, undefined, null, true, 'None');

    this.loginStart = true;
    const timer = this.cookieService.get('mobile_timer');

    this.loginStart = true;
    if(timer){
      this.counterInitialValue = +timer;
    }
    else{
      this.counterInitialValue = 60;
    }

    this.verifyUserForm = new UntypedFormGroup(
      {
        otp: new UntypedFormControl('', [Validators.required])
      },
      { updateOn: 'submit' }
    );

    let client = this.cookieService.get('brand');
    const brand = this.cookieService.get('client');
    this.brand = brand;

    if (brand === 'media'){
      client = 'media';
    }

    let title = client + '.login.browserTitle';
    if (client === 'shaw' || client === 'shaw_direct' || client === 'shaw_enterprise'){
      title = client + '.login.title';
    };

    this.translate.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((langEvent: LangChangeEvent) => {
        this.titleService.setTitle(
          this.translate.instant(title)
        );
      });
    setTimeout(() => {
      this.titleService.setTitle(
        this.translate.instant(title)
      );
    }, 500);

    if (brand === 'r4b' || brand === 'chatr' || brand === 'cpp'
      || brand === 'shaw' || brand === 'shaw_enterprise' || brand === 'shaw_direct'){
      this.showHelp = false;
    }
  }

  ngAfterViewInit(): void {
    this.codeInputRef.inputContainersList.forEach((element, i) => {
      element.nativeElement
        .querySelector('input')
        .setAttribute(
          'title',
          this.translate.instant('rogers.verifyEmail.verificationInput')
        );
    });
    this.codeInputRef.inputsList.first.nativeElement.focus();
  }

  onSubmit = () => {
    this.resetErrorMessage();
    this.formSubmitted = true;
    const isValid = this.otpFieldIsInvalid;
    if (isValid) {
      this.codeInputRef.inputsList.first.nativeElement.focus();
      this.cookieService.set('mobile_timer', JSON.stringify(this.counter),undefined, undefined, null, true, 'None');
      this.onSubmitCode(this.otp);
    }else{
      this.codeInputRef.inputsList.first.nativeElement.focus();
    }

  }

  onResendCode = () => {

    this.resendDisabled = true;
    this.resendCodeClick = true;

    this.onResend();

  }

  onCancel = () => {

  }

  keyDownEnter(event: KeyboardEvent) {
    event.preventDefault();
    this.continueBtn.nativeElement.click();
  }

  onCodeChanged() {
    this.reset();
  }

  onCodeCompleted(code: string) {
    this.otp = code;
  }

  onLiveChat() {
    this.liveChatService.triggerChat('accountRecovery');
  }

  private reset() {
    this.otp = '';
    this.formSubmitted = false;
  }

  get otpFieldIsInvalid() {
    if (this.otp === '' || this.otp.length !== 6){
      return false;
    }
    return true;
  }

  onCounterChange(e): void {
    this.counter = e;
    this.resendDisabled = true;
    if (this.counter === 0) {
      this.resendDisabled = false;
    }
  }

  resetCounter() {
    this.CounterDirective.first.startTimer();
    this.resendDisabled = true;
  }

  onChangeNumber(){
    this.onChangeRecoveryNumber();
  }

  setErrorCode(error: string){
      // this.formSubmitted = true;
      // Storage.removeItem('mobile_timer');

      //  this.formSubmitted = true;
      this.cookieService.delete('mobile_timer');

      this.maxOtpAttemptsTried = false;
      this.incorrectCode = false;
      this.otherError = false;

      if (error === 'locked')
      {
        this.maxOtpAttemptsTried = true;
        this.removeTimer();
      }
      else if (error === 'invalid')
      {
          this.incorrectCode = true; // Incorrect PIN entered
          this.resendDisabled = false;
      }
      else
      {
        this.otherError = true; // some other error
      }
    }

    removeTimer(): void {
      this.resendDisabled = true;
      this.counter = 0;
    }

    resetErrorMessage(): void {
      this.maxOtpAttemptsTried = false;
      this.incorrectCode = false;
      this.otherError = false;
    }

  ngOnDestroy(): void {
  }

}
